export default __webpack_public_path__ + "static/media/t-deposit.8b091a74.webp";